module.exports = __webpack_public_path__ + "static/media/airtel-wallet.f32d01ed.svg";